import { localeToDateFormat } from '@components/time/time.utils';
import { utcToZonedTime } from 'date-fns-tz';
import { useCallback } from 'react';

import { useIntlValue } from '../../contexts/IntlContext';
import { useCurrentUserClientTimezone } from '../../contexts/OidcContext/OidcContext.selectors';
import { useDateFnsFormat } from '../../hooks/useDateFnsFormat';

export const useFormattedDate = () => {
    const dateFormat = useDateFnsFormat();
    const locale = useIntlValue('locale');
    const timezone = useCurrentUserClientTimezone();

    return useCallback(
        (date: number | Date, format?: string) =>
            dateFormat(utcToZonedTime(date, timezone || ''), format || localeToDateFormat[locale]),
        [dateFormat, timezone, locale],
    );
};
